export const faqData = [
  {
    id: 1,
    question: 'オーダーメイドジュエリーの納期はどのくらいですか？',
    answer: 'デザインの複雑さや素材によって異なりますが、通常は打ち合わせから約4〜6週間でお渡しできます。お急ぎの場合はご相談ください。結婚式や記念日に間に合うよう、できる限り対応させていただきます。',
  },
  {
    id: 2,
    question: 'ジュエリーのリメイク料金はいくらくらいですか？',
    answer: 'リメイクの内容によって料金は異なります。基本的なリメイクは3万円から承っております。まずは無料でお見積りいたしますので、お気軽にご相談ください。形見のジュエリーも丁寧に対応いたします。',
  },
  {
    id: 3,
    question: '来店予約は必要ですか？',
    answer: 'ご予約なしでもご来店いただけますが、専門スタッフがじっくりとご相談に乗れるよう、事前のご予約をおすすめしております。お電話またはお問い合わせフォームからご予約ください。',
  },
  {
    id: 4,
    question: 'ブライダルジュエリーの相談は無料ですか？',
    answer: 'はい、ご相談は無料です。結婚指輪や婚約指輪のデザイン、予算、納期など、何でもお気軽にご相談ください。お二人の想いをカタチにするお手伝いをさせていただきます。',
  },
  {
    id: 5,
    question: '修理やサイズ直しもできますか？',
    answer: 'はい、ジュエリーの修理やサイズ直し、クリーニングなども承っております。他店でご購入されたジュエリーでも対応可能です。まずは状態を拝見させていただきますので、お持ちください。',
  },
  {
    id: 6,
    question: '支払い方法は何がありますか？',
    answer: '現金、クレジットカード（VISA、MasterCard、JCB、AMEX）、銀行振込に対応しております。オーダーメイドの場合は、着手金として半額を先にお支払いいただき、完成時に残金をお支払いいただく形となります。',
  },
];